"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALLEY_BANK_AUTH_ADVANCE_RATE_SCOPES = exports.VALLEY_BANK_AUTH_ASSIGNMENT_SCOPES = exports.VALLEY_BANK_USER_ROLES = exports.finleyAssignmentFieldsIterable = exports.valleyBankRequiredBaseFieldsIterable = exports.ValleyBankAccountCollateralTypesIterable = void 0;
// ################################
// #
// # COLLATERAL ACCOUNTS
// #
// ################################
exports.ValleyBankAccountCollateralTypesIterable = [
    'IBS',
    'OPICS',
    'PSPLUS',
];
exports.valleyBankRequiredBaseFieldsIterable = [
    'finley_assigned_to_loan_accounts',
    'finley_receivable_id',
    'finley_loan_product_id',
    'loan_account_number',
    'arrangement_group',
    'cif_num',
    'collateral_account_number',
    'finley_valuation_rate',
    'finley_exposure',
    'pre_allocation_lendable_value',
    'post_allocation_lendable_value',
    'product_name',
];
exports.finleyAssignmentFieldsIterable = [
    'finley_receivable_id',
    'finley_assigned_to_loan_accounts',
    'finley_loan_product_id',
    'loan_account_number',
    'finley_valuation_rate',
    'finley_exposure',
];
exports.VALLEY_BANK_USER_ROLES = [
    'ADMIN',
    'MEMBER',
    'CONTRIBUTOR',
];
exports.VALLEY_BANK_AUTH_ASSIGNMENT_SCOPES = [
    // allows a user to be able to add or delete from the assignment queue
    'assignment.queue:edit',
    // allows a user to be able to submit the assignment queue
    'assignment.queue:submit',
];
exports.VALLEY_BANK_AUTH_ADVANCE_RATE_SCOPES = [
    // can save a WIP (Preview mode on dashboard) advance rate
    'advanceRate:save',
    // can commit current WIP advance rate
    'advanceRate:commit',
];
//# sourceMappingURL=types.js.map